import { Progress } from "antd";
import './progress.scss'
export const ProgressBar = ({ ...rest }) => {
  return <Progress {...rest} />;
};
